import { Capacitor } from '@capacitor/core';
import OneSignal from 'onesignal-cordova-plugin-v3';
import { getStatic } from '../local-storage';
import { getStore } from '../store';
import { updateCurrentMember } from '../store/modules/backend-service';

import { initialize as initializeCallEndpoint } from './call-endpoint';
import { initialize as initializeTelemetry, telemetry } from './telemetry';

export {
  afterLogout,
  callEndpoint,
  checkClientToken,
  EndpointError,
  logout,
  logOutOfOneSignal,
} from './call-endpoint';
export { telemetry } from './telemetry';

export const initialize = async (): Promise<void> => {
  await initializeTelemetry();
  await initializeCallEndpoint({ telemetry });

  const member = await getStatic('backendService', 'member');
  getStore().dispatch(updateCurrentMember(member));
  if (member && member.id && Capacitor.isNativePlatform()) {
    // Setting External User Id with Callback Available in SDK Version 2.9.0+
    OneSignal.setExternalUserId?.(member.id.toString(), (results: unknown) => {
      telemetry(
        telemetry.DEBUG,
        `[initialise] Set external_user_id on OneSignal for ${
          member.id
        }, results: ${JSON.stringify(results)}`,
      );
    });
  }
};
